/* eslint-disable */
// DO NOT EDIT THIS FILE.  This is a gitignored artifact created by Gulp.
// Design tokens should be edited in _patterns/00-config/config.design-tokens.yml
export const PALETTE = {
  "brand": {
    "teal": {
      "base": "#066159",
      "light": "#1A9388",
      "dark": "#0C302D",
      "ultradark": "#0E6C62"
    },
    "blue": {
      "base": "#3E62AE",
      "dark": "#1F3157"
    },
    "red": {
      "base": "#EB1426",
      "light": "#EF4251",
      "dark": "#C32C39",
      "burgandy": "#76323C"
    },
    "rust": {
      "base": "#C74D4C"
    },
    "green": {
      "base": "#BED381",
      "dark": "#8AA74A",
      "other-dark": "#06443E",
      "light": "#149084",
      "social": "#05443D"
    },
    "orange": {
      "base": "#C74D4D",
      "light": "#CF6A17"
    },
    "light-gray": {
      "base": "#E4E4E4"
    },
    "charcoal": {
      "base": "#323332"
    }
  },
  "grayscale": {
    "white": "#fff",
    "gray-0": "#e7e7e7",
    "gray-1": "#f7f7f7",
    "gray-2": "#f1f1f1",
    "gray-3": "#d6d7d9",
    "gray-4": "#aeb0b5",
    "gray-5": "#323332",
    "gray-6": "#323a45",
    "gray-7": "#7B7B7B",
    "gray-10": "#E4E4E4",
    "black": "#222222",
    "black2": "#1A1919"
  },
  "other": {
    "yellow": {
      "base": "#fad980",
      "light": "#fff1d2"
    },
    "yellow-neon": {
      "base": "#ff0"
    },
    "green": {
      "base": "#94bfa2",
      "light": "#e7f4e4"
    },
    "red": {
      "base": "#e31c3d",
      "light": "#e59393",
      "light-1": "#f9dede",
      "dark": "#cd2026",
      "dark-1": "#981b1e"
    }
  }
};

export const BOX_SHADOW = {
  "0": "none",
  "1": "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
  "2": "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)",
  "3": "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  "4": "0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)",
  "5": "0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22)"
};

export const CONSTRAINS = {
  "xs": "700px",
  "sm": "880px",
  "sm-md": "1070px",
  "md": "1440px",
  "md-lg": "1600px",
  "lg": "2200px"
};

export const BREAKPOINTS = {
  "mobile": "320px",
  "mobile-lg": "480px",
  "tablet": "640px",
  "mobile-menu": "1024px",
  "tablet-lg": "900px",
  "desktop": "1024px",
  "desktop-smmd": "1070px",
  "desktop-lg": "1200px",
  "widescreen": "1400px",
  "highdef": "1600px"
};

export const COLORS = {
  "text": {
    "primary": "#323332",
    "secondary": "#222222",
    "tertiary": "#0C302D",
    "on-light": "#222222",
    "on-dark": "#fff",
    "link": "#1A1919",
    "link-hover": "#066159",
    "link-active": "#066159",
    "link-visited": "#066159"
  },
  "background": {
    "site": "#fff"
  },
  "button": {
    "primary": {
      "background": "#066159",
      "background-hover": "#323332",
      "background-active": "#066159",
      "border": "#066159",
      "border-hover": "#323332",
      "text": "#fff",
      "text-hover": "#fff",
      "text-active": "#fff"
    },
    "disabled": {
      "background": "#f1f1f1",
      "border": "#f1f1f1",
      "text": "#aeb0b5"
    },
    "danger": {
      "background": "#e31c3d",
      "background-hover": "#cd2026",
      "background-active": "#981b1e",
      "border": "#e31c3d",
      "border-hover": "#cd2026",
      "text": "#fff",
      "text-hover": "#fff",
      "text-active": "#fff"
    },
    "back-to-top": {
      "background": "#aeb0b5",
      "background-hover": "#323332",
      "color": "#fff",
      "color-hover": "#fff"
    }
  },
  "form": {
    "background": "#f7f7f7",
    "background-active": "#fff",
    "background-checked": "#3E62AE",
    "background-unchecked": "#fff",
    "border": "#d6d7d9",
    "border-dark": "#323332",
    "border-light": "#f7f7f7",
    "thumb": "#323332",
    "track": "#aeb0b5"
  },
  "mark": {
    "background": "#ff0",
    "text": "#222222"
  },
  "selection": {
    "background": "#3E62AE",
    "text": "#fff"
  },
  "table": {
    "border": "#323332",
    "background": "#fff",
    "background-head": "#f1f1f1",
    "background-foot": "#f1f1f1"
  },
  "ui": {
    "generic": {
      "background": "#aeb0b5",
      "background-darker": "#222222",
      "background-dark": "#323a45",
      "background-light": "#f1f1f1",
      "background-lighter": "#f7f7f7",
      "border": "#aeb0b5",
      "border-dark": "#323a45",
      "border-light": "#f1f1f1",
      "text-lighter": "#fff",
      "text-light": "#aeb0b5",
      "text-dark": "#323332",
      "text-darker": "#222222",
      "accent": "#066159",
      "accent-dark": "#0C302D",
      "accent-light": "#1A9388",
      "focus": "#1A9388"
    },
    "error": {
      "background": "#f9dede",
      "border": "#e59393"
    },
    "success": {
      "background": "#e7f4e4",
      "border": "#94bfa2"
    },
    "warning": {
      "background": "#fff1d2",
      "border": "#fad980"
    }
  }
};

export const TYPOGRAPHY = {
  "font-family": {
    "primary": {
      "name": "Primary",
      "stack": "\"Poppins\", sans-serif"
    },
    "secondary": {
      "name": "Secondary",
      "stack": "\"Rubik\", sans-serif"
    },
    "system": {
      "name": "System",
      "stack": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Oxygen-Sans\", Ubuntu, Cantarell, \"Fira Sans\", Droid Sans, sans-serif"
    },
    "monospace": {
      "name": "Monospace",
      "stack": "Menlo, Consolas, \"Lucida Console\", \"Liberation Mono\", \"Courier New\", monospace, sans-serif"
    }
  },
  "base-font-size": "18px",
  "font-size": {
    "1": "16px",
    "2": "18px",
    "3": "20px",
    "4": "26px",
    "5": "32px",
    "6": "40px",
    "7": "48px",
    "8": "56px",
    "9": "90px",
    "10": "105px",
    "0.3": "12px",
    "0.5": "14px"
  },
  "font-weight": {
    "regular": 400,
    "semibold": 600,
    "bold": 700
  },
  "line-height": {
    "tight": 1.1,
    "medium": 1.45,
    "base": 1.6,
    "loose": 1.7
  },
  "display": {
    "display": {
      "color": "#323332",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "105px",
      "font-weight": 700,
      "line-height": 1.1
    },
    "h1": {
      "color": "#0C302D",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "56px",
      "font-weight": 700,
      "line-height": 1.1
    },
    "h2": {
      "color": "#0E6C62",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "40px",
      "font-weight": 700,
      "line-height": 1.1
    },
    "h3": {
      "color": "#05443D",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "32px",
      "font-weight": 700,
      "line-height": 1.1
    },
    "h4": {
      "color": "#066159",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "26px",
      "font-weight": 700,
      "line-height": 1.6
    },
    "h5": {
      "color": "#0C302D",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "20px",
      "font-weight": 700,
      "line-height": 1.6
    },
    "h6": {
      "color": "#0C302D",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "14px",
      "font-weight": 600,
      "letter-spacing": "-0.04em",
      "line-height": 1.7,
      "text-transform": "uppercase"
    },
    "blockquote": {
      "color": "#1A1919",
      "font-family": "\"Rubik\", sans-serif",
      "font-size": "26px",
      "font-weight": 400,
      "line-height": 1.6
    },
    "body": {
      "color": "#323332",
      "font-family": "\"Poppins\", sans-serif",
      "font-size": "18px",
      "font-weight": 400,
      "line-height": 1.6
    },
    "body-large": {
      "color": "#323332",
      "font-family": "\"Poppins\", sans-serif",
      "font-size": "20px",
      "font-weight": 400,
      "line-height": 1.6
    },
    "cite": {
      "color": "#222222",
      "font-family": "\"Poppins\", sans-serif",
      "font-size": "16px",
      "font-style": "normal",
      "font-weight": 600,
      "line-height": 1.1
    }
  }
};

export const TRANSITIONS = {
  "ease": {
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
    "ease-out": "cubic-bezier(0.0, 0, 0.2, 1)",
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "sharp": "cubic-bezier(0.4, 0, 0.6, 1)"
  },
  "duration": {
    "shortest": "150ms",
    "short": "200ms",
    "standard": "375ms",
    "long": "400ms",
    "intro": "270ms",
    "outro": "195ms"
  }
};

export const Z_INDEX = {
  "nav": 1000,
  "drawer": 1200,
  "modal": 1300
};

export const SPACING = {
  "0": 0,
  "1": "8px",
  "2": "16px",
  "3": "24px",
  "4": "32px",
  "5": "40px",
  "6": "48px",
  "7": "56px",
  "8": "64px",
  "9": "72px",
  "10": "80px",
  "12": "96px",
  "15": "120px",
  "0.5": "4px",
  "1.5": "12px",
  "2.5": "20px"
};

export const GUTTER_WIDTH = "40px";

